import * as React from 'react'

import { LogOutIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import {
  SidebarIconColumn,
  SidebarTitleColumn,
} from './SidebarSections/SidebarSections'

interface ISidebarLogout {
  onClick: () => void
}

@observer
export default class SidebarLogoutItem extends React.Component<ISidebarLogout> {
  public render() {
    return (
      <div
        onClick={this.onClick}
        className="bg-white bb-cool-grey h48 row indication-click"
      >
        <SidebarIconColumn isDisabled={false}>
          <LogOutIcon size={22} className="tw:text-foreground" />
        </SidebarIconColumn>
        <SidebarTitleColumn
          text={Localization.translator.logOut}
          isDisabled={false}
          bold={false}
          isBadgeShown={false}
        />
      </div>
    )
  }

  private onClick = (evt: React.MouseEvent<HTMLDivElement>) => {
    evt.preventDefault()

    this.props.onClick()
  }
}
